// extracted by mini-css-extract-plugin
export var dataCell = "_rr-2";
export var dataRow = "_rr-0";
export var headerRow = "_rr-1";